import React, { Component } from "react";
import moment from "moment";
import { Alert, Row, Col } from "reactstrap";
import { UsersList } from "./";
import StudentLicenseFilters from "./StudentLicenseFilters";
import getAllClasses from "../../../helpers/users/licenses/getAllClasses";
import forOwn from "mout/object/forOwn";
const DATE_FORMAT = "MM/DD/YYYY";

class SelectLicenseRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment(Number(this.props.license.startDate)).format(
        DATE_FORMAT
      ),
      endDate: moment(Number(this.props.license.endDate)).format(DATE_FORMAT),
      saving: false,
      error: "",
      changed: false,
      deleting: false,
      showQuantity: true,
      teachersInSchool: null,
      classesOfTeacher: null,
      filteredStudentsByClass: null,
      filteredStudentsByTeacher: null,
      selectedTeacher: null,
      selectedClassOfTeacher: null
    };
    this.getSelectedTeacher = this.getSelectedTeacher.bind(this);
    this.getSelectedClass = this.getSelectedClass.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.users !== this.props.users &&
      this.state.selectedTeacher === prevState.selectedTeacher
    ) {
      if (this.state.filteredStudentsByClass !== null) {
        let filteredStudentsByClass = [];
        if (this.state.selectedClassOfTeacher !== null) {
          if (this.state.filteredStudentsByTeacher) {
            forOwn(
              this.state.selectedClassOfTeacher.students,
              (studentOfClass, studentOfClassKey) => {
                forOwn(this.props.users, student => {
                  if (studentOfClassKey === student.id) {
                    if (student.classes[this.state.selectedClassOfTeacher.id]) {
                      filteredStudentsByClass.push(student);
                    }
                  }
                });
              }
            );

            if (filteredStudentsByClass.length > 0) {
              let studentsWithChangedLicenseFilteredByTeacher = [];

              if (this.state.filteredStudentsByTeacher) {
                forOwn(
                  this.state.filteredStudentsByTeacher,
                  (studentOfTeacher, studentOfTeachersKey) => {
                    forOwn(
                      filteredStudentsByClass,
                      (studentInClass, studentInClassKey) => {
                        if (studentInClass.id === studentOfTeacher.id) {
                          studentsWithChangedLicenseFilteredByTeacher.push(
                            studentInClass
                          );
                        }
                      }
                    );
                  }
                );
              }
              this.setState({
                filteredStudentsByClass,
                filteredStudentsByTeacher: studentsWithChangedLicenseFilteredByTeacher
              });
            } else {
              this.setState({ filteredStudentsByClass: [] });
            }
          }
        }
      } else {
        if (this.state.selectedTeacher !== null) {
          let arr = [];
          if (this.state.selectedTeacher.classes !== null) {
            forOwn(
              this.state.selectedTeacher.classes,
              (teacherClass, teacherClassKey) => {
                forOwn(this.props.users, student => {
                  if (student.classes) {
                    if (student.classes[teacherClassKey]) {
                      arr.push(student);
                    }
                  }
                });
              }
            );
            this.setState({ filteredStudentsByTeacher: arr });
          }
        }
      }
    }
  }

  getSelectedTeacher(selectedOption) {
    const { users } = this.props;
    if (selectedOption.label === "----") {
      this.setState({
        selectedTeacher: null,
        selectedClassOfTeacher: null,
        filteredStudentsByClass: null,
        filteredStudentsByTeacher: null
      });
    } else {
      this.setState({
        selectedTeacher: selectedOption
      });
      const { schoolId } = this.props;
      let filteredStudentsByTeacher = [];

      if (selectedOption.classes) {
        getAllClasses(
          schoolId,
          selectedOption.id,
          this.setState.bind(this)
        ).then(classes => {
          this.setState({
            classesOfTeacher: classes,
            filteredStudentsByClass: null
          });
          if (selectedOption.classes) {
            forOwn(selectedOption.classes, (teacherClass, teacherClassKey) => {
              forOwn(users, (student, key) => {
                if (student.classes[teacherClassKey]) {
                  filteredStudentsByTeacher.push(student);
                }
              });
            });
            if (filteredStudentsByTeacher.length > 0) {
              this.setState({ filteredStudentsByTeacher });
            } else {
              this.setState({ filteredStudentsByTeacher: [] });
            }
          }
        });
      }
    }
  }
  resetFilter() {
    this.setState({
      selectedClassOfTeacher: null,
      selectedTeacher: null,
      filteredStudentsByTeacher: null,
      filteredStudentsByClass: null
    });
  }

  getSelectedClass(selectedClass) {
    if (selectedClass.label === "----") {
      this.setState({
        selectedClassOfTeacher: null,
        filteredStudentsByClass: null
      });
    } else {
      this.setState({
        selectedClassOfTeacher: selectedClass
      });
      let filteredStudentsByClass = [];

      if (selectedClass) {
        if (selectedClass.students) {
          forOwn(
            selectedClass.students,
            (studentOfClass, studentOfClassKey) => {
              forOwn(this.state.filteredStudentsByTeacher, student => {
                if (studentOfClassKey === student.id) {
                  filteredStudentsByClass.push(student);
                }
              });
            }
          );
        }
      }

      if (filteredStudentsByClass.length > 0) {
        this.setState({ filteredStudentsByClass });
      } else {
        this.setState({ filteredStudentsByClass: [] });
      }
    }
  }

  render() {
    const { startDate, endDate, error, classesOfTeacher } = this.state;
    const {
      license,
      handleClick,
      activeLicense,
      users,
      toggleUserLicense,
      userType,
      removeOrAddAll,
      addingOrRemovingAll,
      addRemoveError,
      parentId,
      teachersInSchool,
      licenseLimitExceedError
    } = this.props;
    const { licensedCount, id, licensedMax, name } = license;

    const { filteredStudentsByClass, filteredStudentsByTeacher } = this.state;

    const { getSelectedClass, getSelectedTeacher } = this;

    const userRender = !!filteredStudentsByClass
      ? filteredStudentsByClass
      : !!filteredStudentsByTeacher
      ? filteredStudentsByTeacher
      : users;
    return (
      <React.Fragment>
        <tr
          onClick={() => {
            handleClick(id);
          }}
          className={`license-row-clickable ${
            license.id === activeLicense ? "active-license-row" : ""
          }`}
        >
          <td scope="row">{name}</td>
          <td>
            <span className="quantity-text">
              {licensedCount} out of {licensedMax} used.
            </span>
          </td>
          <td>{startDate}</td>
          <td>{endDate}</td>
        </tr>
        {addRemoveError && (
          <tr className="bg-white">
            <td colSpan="12">
              <Alert>{addRemoveError}</Alert>
            </td>
          </tr>
        )}
        {license.id === activeLicense && (
          <React.Fragment>
            {parentId === "student_license" && (
              <React.Fragment>
                <tr className="bg-white">
                  <td colSpan="12">
                    <StudentLicenseFilters
                      teachersInSchool={teachersInSchool}
                      classesInSchool={classesOfTeacher}
                      getSelectedTeacher={getSelectedTeacher}
                      getSelectedClass={getSelectedClass}
                      resetFilter={this.resetFilter}
                    />
                  </td>
                </tr>
                <tr className="bg-white">
                  <td colSpan="12">
                    {userRender && userRender.length === 0 && (
                      <Alert color="warning">
                        No data is available to view.
                      </Alert>
                    )}
                  </td>
                </tr>
              </React.Fragment>
            )}
            {
              licenseLimitExceedError && (<React.Fragment>
                <tr className="bg-white">
                  <td colSpan="12">
                    <Alert color="danger">
                        Can not assign license. Limit exceeded.
                    </Alert>
                  </td>
                </tr>
              </React.Fragment>)
            }
            <tr className="bg-white">
              <td colSpan="12">
                <Row>
                  <Col xs="12" md="6">
                    <UsersList
                      notAssignedLicense={true}
                      users={
                        !!filteredStudentsByClass
                          ? filteredStudentsByClass
                          : !!filteredStudentsByTeacher
                          ? filteredStudentsByTeacher
                          : users
                      }
                      license={activeLicense}
                      toggle={toggleUserLicense}
                      userType={userType}
                      removeOrAddAll={removeOrAddAll}
                      addingOrRemovingAll={addingOrRemovingAll}
                    />
                  </Col>
                  <Col xs="12" md="6">
                    <UsersList
                      assignedLicense={true}
                      users={
                        !!filteredStudentsByClass
                          ? filteredStudentsByClass
                          : !!filteredStudentsByTeacher
                          ? filteredStudentsByTeacher
                          : users
                      }
                      license={activeLicense}
                      toggle={toggleUserLicense}
                      userType={userType}
                      removeOrAddAll={removeOrAddAll}
                      addingOrRemovingAll={addingOrRemovingAll}
                    />
                  </Col>
                </Row>
              </td>
            </tr>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default SelectLicenseRow;



// WEBPACK FOOTER //
// ./src/components/Users/Licenses/SelectLicenseRow.js